import { useEffect, useState } from "react";
import { getToken } from "../../utils/tokenUtils";

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState(null);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const token = getToken();

  console.log("dashboard data for config:", dashboardData?.config);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        "https://hrmsnew.prepstripe.com/api/payroll/dashboard",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.status === "success") {
        setDashboardData(data?.data);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch data");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const CountUpNumber = ({ target }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      let start = 0;
      const duration = 1000; // total duration in ms
      const stepTime = Math.max(Math.floor(duration / target), 10);

      const interval = setInterval(() => {
        start += 1;
        setCount(start);
        if (start >= target) {
          clearInterval(interval);
        }
      }, stepTime);

      return () => clearInterval(interval);
    }, [target]);

    return <span>{count}</span>;
  };

  // const { summary, history, config } = dashboardData;

  return (
    <div className="min-h-screen font-poppins">
      <div className="px-4 py-2  mx-auto">
        {/* Header */}
        <div className="flex flex-wrap justify-between items-center gap-4 gap-y-4 mb-6 mt-4">
          <div className="flex flex-col">
            <h1 className="text-3xl font-semibold font-poppins text-gray-900 dark:text-white">
              Payroll
            </h1>
            <small className="text-[#4B5563] text-[16px] dark:text-gray-400">
              Manage employee salaries and payroll processing
            </small>
          </div>
          <div className="flex flex-wrap justify-end items-center space-x-2 text-sm">
            <button className="flex items-center gap-2 md:w-auto w-full border border-[#E2E8F0] dark:bg-gray-900 dark:border-gray-700 bg-white px-3 py-2 rounded-[10px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                className="dark:text-white"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" x2="12" y1="15" y2="3" />
              </svg>
              <span className="dark:text-white text-[14px] font-poppins">
                Export Payroll
              </span>
            </button>

            <button className="flex items-center gap-2 md:w-auto w-full bg-[#2563EB] px-3 py-2 rounded-[10px] mt-2 sm:mt-0">
              <svg
                className="w-5 h-5 text-white"
                data-slot="icon"
                aria-hidden="true"
                fill="none"
                strokeWidth="1.5"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span className="text-white text-[14px] font-poppins">
                Process Payroll
              </span>
            </button>
          </div>
        </div>

        {/* Main Grid Layout */}
        <div className="grid grid-cols-1 gap-6">
          {/* Left Column - Stats and Chart */}
          <div className="col-span-4 space-y-6">
            {/* Top Stats Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
              {/* Card 1 */}
              <div className="bg-white dark:bg-gray-900 rounded-[20px] px-4 py-[12px] shadow-md dark:border-gray-700">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <div className="text-[15px] font-poppins font-medium text-[#565563] dark:text-white mt-1">
                      Total Employees
                    </div>
                    <div className="text-xl font-semibold text-[#22C55E]">
                      {/* {dashboardData?.summary?.total_employees} */}₹{" "}
                      {dashboardData?.summary?.total_employees
                        ? parseFloat(
                            dashboardData.summary.total_employees,
                          ).toLocaleString()
                        : "0"}
                    </div>
                    <div className="flex gap-2 items-center text-sm dark:text-[#6B7290] font-poppins">
                      {dashboardData?.summary?.month}
                    </div>
                  </div>
                  <div
                    className={`w-10 h-10 bg-[#22C55E] text-white p-1 rounded-lg flex items-center justify-center`}
                  >
                    <svg
                      data-slot="icon"
                      aria-hidden="true"
                      fill="none"
                      stroke-width="1.5"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 8.25H9m6 3H9m3 6-3-3h1.5a3 3 0 1 0 0-6M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>

              {/* Card 2 */}
              <div className="bg-white dark:bg-gray-900 rounded-[20px] px-4 py-[12px] shadow-md dark:border-gray-700">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <div className="text-[15px] font-poppins font-medium text-[#565563] dark:text-white mt-1">
                      Total Payroll
                    </div>
                    <div className="text-xl font-semibold text-[#2563EB]">
                      {/* ₹ {parseFloat(dashboardData?.summary?.total_payroll).toLocaleString()} */}
                      ₹{" "}
                      {dashboardData?.summary?.total_payroll
                        ? parseFloat(
                            dashboardData.summary.total_payroll,
                          ).toLocaleString()
                        : "0"}
                    </div>
                    <div className="flex gap-2 items-center text-sm text-[#6B7290] font-poppins">
                      out of 250
                    </div>
                  </div>
                  <div
                    className={`w-10 h-10 bg-[#2563EB] text-white p-1 rounded-lg flex items-center justify-center`}
                  >
                    <svg
                      className="dark:text-white"
                      data-slot="icon"
                      aria-hidden="true"
                      fill="none"
                      stroke-width="1.5"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>

              {/* Card 3 */}
              <div className="bg-white dark:bg-gray-900 rounded-[20px] px-4 py-[12px] shadow-md dark:border-gray-700">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <div className="text-[15px] font-poppins font-medium text-[#565563] dark:text-white mt-1">
                      Avg. Salary
                    </div>
                    <div className="text-xl font-semibold text-[#A855F7]">
                      {/* ₹ {parseFloat(dashboardData?.summary?.avg_salary).toLocaleString()} */}
                      ₹{" "}
                      {dashboardData?.summary?.avg_salary
                        ? parseFloat(
                            dashboardData.summary.avg_salary,
                          ).toLocaleString()
                        : "0"}
                    </div>
                    <div className="flex gap-2 items-center text-sm text-[#6B7290] font-poppins">
                      per employee
                    </div>
                  </div>
                  <div
                    className={`w-10 h-10 bg-[#A855F7] text-white p-1 rounded-lg flex items-center justify-center`}
                  >
                    <svg
                      className="dark:text-white"
                      data-slot="icon"
                      aria-hidden="true"
                      fill="none"
                      stroke-width="1.5"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>

              {/* Card 4 */}
              <div className="bg-white dark:bg-gray-900 rounded-[20px] px-4 py-[12px] shadow-md dark:border-gray-700">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <div className="text-[15px] font-poppins font-medium text-[#565563] dark:text-white mt-1">
                      Pending Approvals
                    </div>
                    <div className="text-xl font-semibold text-[#F97316]">
                      12
                    </div>
                    <div className="flex gap-2 items-center text-sm text-[#6B7290] font-poppins">
                      employee
                    </div>
                  </div>
                  <div
                    className={`w-10 h-10 bg-[#F97316] text-white p-1 rounded-lg flex items-center justify-center`}
                  >
                    <svg
                      className="dark:text-white"
                      data-slot="icon"
                      aria-hidden="true"
                      fill="none"
                      stroke-width="1.5"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Payroll summary */}
        <div className="grid grid-cols-1 gap-6 mt-3">
          <div className="">
            <div className="bg-white shadow-md dark:bg-gray-900 px-4 py-4 rounded-[10px] dark:border dark:border-gray-700">
              <div>
                <h1 className="text-black dark:text-white text-[20px] font-poppins font-semibold">
                  Payroll Summary
                </h1>
                <p className="text-[#64748B] font-poppins text-[14px]">
                  Monthly payroll processing history
                </p>
              </div>
              <div className="flex flex-col gap-y-4 mt-4">
                {dashboardData?.history.map((record, index) => {
                  const processedDate = new Date(record?.processed_on);
                  const formattedDate = processedDate
                    .toISOString()
                    .split("T")[0];
                  const status = index === 0 ? "Processed" : "Completed";
                  const statusColor =
                    index === 0
                      ? "bg-[#F2EBEB] text-[#6B7280]"
                      : "bg-[#2563EB] text-white";

                  return (
                    <div className="flex flex-col items-start justify-start gap-y-3 dark:bg-black cursor-pointer shadow-md dark:border dark:border-gray-700 dark:hover:border-blue-700 hover:border-blue-500 transform transition duration-300  p-4 rounded-[10px]">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full gap-4">
                        <div className="flex flex-col items-start">
                          <p className="dark:text-white font-poppins">
                            {record?.month}
                          </p>
                          <p className="text-sm text-[#6B7280] font-poppins">
                            {record?.total_employees} employees • Processed on 
                            {formattedDate}
                          </p>
                        </div>
                        <div className="flex items-center gap-4">
                          <div className="flex flex-col items-center gap-y-2">
                            <p className="text-[#16A34A] text-[18px] font-semibold font-poppins">
                              ₹ {record?.total_amount}
                            </p>
                            <p className="text-[12px] text-[#6B7280] bg-[#F2EBEB] px-4 p-1 rounded-full font-medium font-poppins">
                              Processed
                            </p>
                          </div>
                          {/* <button className="flex items-center gap-1 border border-[#E2E8F0] font-poppins dark:border-gray-700 md:px-2 md:py-2 p-2 text-sm md:text-md dark:text-white rounded-[5px]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                              class="main-grid-item-icon"
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline points="14 2 14 8 20 8" />
                              <line x1="16" x2="8" y1="13" y2="13" />
                              <line x1="16" x2="8" y1="17" y2="17" />
                              <polyline points="10 9 9 9 8 9" />
                            </svg>

                            <span>View Details</span>
                          </button> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Employee Payroll - May 2024 */}
        {/* <div className="grid grid-cols-1 gap-6 mt-1">
          <div className="bg-white dark:bg-gray-900 p-4 rounded-[10px] shadow-md dark:border dark:border-gray-700 items-center gap-4 mb-2 mt-4">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-y-3 mb-4">
              <div className="flex flex-col">
                <h1 className="text-black dark:text-white text-lg font-poppins font-semibold">
                  Employee Payroll - May 2024
                </h1>
                <p className="text-[#64748B] font-poppins text-[15px]">
                  Individual salary breakdown and payment status
                </p>
              </div>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                <div className="relative flex items-center">
                  <svg
                    className="w-4 h-4 dark:text-white absolute top-1/2 left-3 -translate-y-1/2"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.1167 9.83536H10.4391L10.199 9.6038C11.0685 8.59524 11.5464 7.30765 11.5455 5.97601C11.5455 4.87346 11.2185 3.79566 10.606 2.87892C9.99343 1.96218 9.1228 1.24767 8.10417 0.825742C7.08554 0.403813 5.96467 0.293417 4.8833 0.508515C3.80193 0.723613 2.80863 1.25454 2.02901 2.03417C1.24939 2.81379 0.718455 3.80709 0.503357 4.88846C0.28826 5.96983 0.398656 7.0907 0.820585 8.10932C1.24251 9.12795 1.95703 9.99859 2.87377 10.6111C3.79051 11.2237 4.8683 11.5506 5.97086 11.5506C7.35164 11.5506 8.62094 11.0446 9.59864 10.2041L9.8302 10.4443V11.1218L14.1184 15.4014L15.3962 14.1235L11.1167 9.83536ZM5.97086 9.83536C3.83535 9.83536 2.11151 8.11152 2.11151 5.97601C2.11151 3.84051 3.83535 2.11667 5.97086 2.11667C8.10636 2.11667 9.8302 3.84051 9.8302 5.97601C9.8302 8.11152 8.10636 9.83536 5.97086 9.83536Z"
                      fill="#7A7B7F"
                    />
                  </svg>
                  <input
                    type="text"
                    className="dark:bg-black dark:text-white font-poppins border dark:border-gray-700 dark:focus:border-blue-500 dark:focus:border-2 bg-white text-black border-[#DEDEDE] placeholder:text-[#7A7B7F] rounded-[15px] w-[247px] h-[45px] px-10 focus:outline-none"
                    placeholder="Search employees.."
                  />
                </div>
                <button className="flex items-center gap-2 font-poppins dark:bg-black dark:border-gray-700 dark:text-white text-black border border-[#E2E8F0] rounded-[10px] text-[16px] px-3 py-2 bg-white hover:border-gray-500">
                  <svg
                    className="w-4 h-4 dark:text-white -rotate-45"
                    fill="none"
                    stroke-width="1.5"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>Send Payslips</span>
                </button>
              </div>
            </div>
            
            <div className="overflow-x-auto  mt-6">
              <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="border-b border-[#E2E8F0] dark:border-gray-700">
                  <tr>
                    <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-gray-300 font-poppins">
                      Employee
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-gray-300 font-poppins">
                      Allowances
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-gray-300 font-poppins">
                      Deductions
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-black dark:text-gray-300 font-poppins">
                      Net Salary
                    </th>
                    <th className="px-4 py-2 text-center text-sm font-medium text-black dark:text-gray-300 font-poppins">
                      Status
                    </th>
                    <th className="px-4 py-2 text-center text-sm font-medium text-black dark:text-gray-300 font-poppins">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white font-poppins">
                      <div className="flex flex-col items-start">
                        <p>Sarah Johnson</p>
                        <p className="text-[#6B7280]">
                          EMP001 • Senior Software Engineer
                        </p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white font-poppins font-medium">
                      ₹ 85,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#16A34A] font-poppins font-medium">
                      ₹ 15,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#E63E3E] font-poppins font-medium">
                      ₹ 85,000
                    </td>
                    <td className="px-4 py-2 text-sm text-white text-center font-poppins">
                      <span className="px-3 py-1 text-[12px] font-medium bg-[#2563EB] rounded-full">
                        Processed
                      </span>
                    </td>
                    <td className="px-4 py-2 flex items-center justify-center gap-4 mt-3">
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" x2="8" y1="13" y2="13" />
                          <line x1="16" x2="8" y1="17" y2="17" />
                          <polyline points="10 9 9 9 8 9" />
                        </svg>
                      </button>
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" x2="12" y1="15" y2="3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                  <tr className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 font-poppins">
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white">
                      <div className="flex flex-col items-start gap-y-1">
                        <p>Michael Chen</p>
                        <p className="text-[#6B7280]">
                          EMP002 • Product Manager
                        </p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white font-poppins font-medium">
                      ₹ 15,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#16A34A] font-poppins font-medium">
                      ₹ 15,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#E63E3E] font-poppins font-medium">
                      ₹ 85,000
                    </td>
                    <td className="px-4 py-2 text-sm text-black text-center font-poppins">
                      <span className="px-5 py-1 text-[12px] font-medium bg-gray-200 rounded-full">
                        Pending
                      </span>
                    </td>
                    <td className="px-4 py-2 flex items-center justify-center gap-4 mt-3">
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" x2="8" y1="13" y2="13" />
                          <line x1="16" x2="8" y1="17" y2="17" />
                          <polyline points="10 9 9 9 8 9" />
                        </svg>
                      </button>
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" x2="12" y1="15" y2="3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                  <tr className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white font-poppins">
                      <div className="flex flex-col items-start gap-y-1">
                        <p>Emily Davis</p>
                        <p className="text-[#6B7280]">EMP003 • UX Designer</p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white font-poppins font-medium">
                      ₹ 15,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#16A34A] font-poppins font-medium">
                      ₹ 15,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#E63E3E] font-poppins font-medium">
                      ₹ 85,000
                    </td>
                    <td className="px-4 py-2 text-sm text-white text-center font-poppins">
                      <span className="px-3 py-1 text-[12px] font-medium  bg-[#2563EB] rounded-full">
                        Processed
                      </span>
                    </td>
                    <td className="px-4 py-2 flex items-center justify-center gap-4 mt-3">
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" x2="8" y1="13" y2="13" />
                          <line x1="16" x2="8" y1="17" y2="17" />
                          <polyline points="10 9 9 9 8 9" />
                        </svg>
                      </button>
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" x2="12" y1="15" y2="3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                  <tr className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white font-poppins">
                      <div className="flex flex-col items-start gap-y-1">
                        <p>David Wilson</p>
                        <p className="text-[#6B7280]">
                          EMP004 • Marketing Manager
                        </p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-900 dark:text-white font-poppins font-medium">
                      ₹ 15,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#16A34A] font-poppins font-medium">
                      ₹ 15,000
                    </td>
                    <td className="px-4 py-2 text-sm text-[#E63E3E] font-poppins font-medium">
                      ₹ 85,000
                    </td>
                    <td className="px-4 py-2 text-sm text-white text-center font-poppins">
                      <span className="px-3 py-1 text-[12px] font-medium  bg-[#2563EB] rounded-full">
                        Processed
                      </span>
                    </td>
                    <td className="px-4 py-2 flex items-center justify-center gap-4 mt-3">
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" x2="8" y1="13" y2="13" />
                          <line x1="16" x2="8" y1="17" y2="17" />
                          <polyline points="10 9 9 9 8 9" />
                        </svg>
                      </button>
                      <button className="hover:underline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-5 h-5 text-black dark:text-white"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" x2="12" y1="15" y2="3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}

        {/* Payroll summary */}
        <div className="grid grid-cols-1 gap-6 mt-3">
          <div className="">
            <div className="bg-white dark:bg-gray-900 px-4 py-4 shadow-md dark:border dark:border-gray-700 rounded-[10px]">
              <div>
                <h1 className="text-black dark:text-white text-lg font-poppins font-semibold">
                  Salary Component Breakdown
                </h1>
                <p className="text-[#64748B] font-poppins">
                  Distribution of salary components across the organization
                </p>
              </div>
              <div className="flex flex-col gap-y-4 mt-4">
                {/* card 1 */}
                {dashboardData?.config?.map((record, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-start justify-start gap-y-3 font-poppins dark:bg-black cursor-pointer border-b dark:border-gray-700 dark:hover:border-blue-700 hover:border-blue-500 transform transition duration-300 p-4"
                  >
                    <div className="flex items-center justify-between w-full">
                      <div className="flex items-center gap-2">
                        <div className="bg-[#3B82F6] w-3 h-3 rounded-full"></div>
                        <p className="dark:text-white">
                          {record?.component_name}
                        </p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="text-green-600 font-medium">
                          {record?.percentage
                            ? `${parseFloat(record.percentage).toFixed(0)}%`
                            : "0%"}
                        </p>
                        <p className="dark:text-white font-medium">
                          ₹ {record?.default_value ? record.default_value : 0}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
